export default __webpack_public_path__ + "static/media/profile2.fc3ace4f.png";